import { ReactComponent as TargetIcon } from "@assets/images/icons/target-icon.svg";
import { ReactComponent as PeopleSearch } from "@assets/images/icons/people-search.svg";
import { ReactComponent as ChessIcon } from "@assets/images/icons/chess-icon.svg";
import { ReactComponent as DashedLine } from "@assets/images/icons/dashed-line.svg";

import "./CopytradeFollowTraders.sass";

export const CopytradeFollowTraders = () => {
  return (
    <div className="copytrade-follow">
      <h3 className="copytrade-follow__title">
        Follow professional traders automatically
      </h3>

      <div className="copytrade-follow__content">
        <div className="copytrade-follow__block">
          <div className="copytrade-follow__block-top">
            <PeopleSearch />

            <DashedLine />
          </div>

          <h4 className="copytrade-follow__block-title">
            Step 1 — Find top traders
          </h4>

          <p className="copytrade-follow__block-description">
            Explore top-performing traders based on ROI, risk level, and
            strategy.
          </p>
        </div>

        <div className="copytrade-follow__block">
          <div className="copytrade-follow__block-top">
            <ChessIcon />

            <DashedLine />
          </div>

          <h4 className="copytrade-follow__block-title">
            Step 2 — Customize your strategy
          </h4>

          <p className="copytrade-follow__block-description">
            Control risk, investment size, and trade limits before copying.
          </p>
        </div>

        <div className="copytrade-follow__block">
          <div className="copytrade-follow__block-top">
            <TargetIcon />
          </div>

          <h4 className="copytrade-follow__block-title">
            Step 3 — Let the system trade
          </h4>

          <p className="copytrade-follow__block-description">
            Trades are executed in real time, exactly like the selected trader.
          </p>
        </div>
      </div>
    </div>
  );
};
